import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  height: 100%;
  padding: 40px 16px 10px;

  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`

export const Title = styled.h1`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 22px;
  color: ${props => props.theme.colors.color2d3139};

  margin-bottom: 32px;
`
